export const NAV_SECTIONS = {
  movies: {
    key: 'movies',
    title: 'Movies',
    icon: 'mdi-movie-open',
    color: '#6366f1',
    gradient: 'linear-gradient(135deg, #6366f1, #818cf8)',
    items: [
      { title: 'Movies', to: '/movies/homeview', icon: 'mdi-movie' },
      { title: 'Wish list', to: '/movies/wishlist', icon: 'mdi-bookmark-plus' },
      { title: 'Add movie', to: '/movies/add-post', icon: 'mdi-plus' },
      { title: 'Search', to: '/movies/search', icon: 'mdi-magnify' },
    ],
  },
  books: {
    key: 'books',
    title: 'Books',
    icon: 'mdi-book-open-page-variant',
    color: '#10b981',
    gradient: 'linear-gradient(135deg, #10b981, #34d399)',
    items: [
      { title: 'Books', to: '/books/homeview', icon: 'mdi-book-open-page-variant' },
      { title: 'Wish list', to: '/books/wishlist', icon: 'mdi-bookmark-plus' },
      { title: 'Add book', to: '/books/add-post', icon: 'mdi-plus' },
      { title: 'Search', to: '/books/search', icon: 'mdi-magnify' },
    ],
  },
  audiobooks: {
    key: 'audiobooks',
    title: 'AudioBooks',
    icon: 'mdi-headphones',
    color: '#f43f5e',
    gradient: 'linear-gradient(135deg, #f43f5e, #fb7185)',
    items: [
      { title: 'AudioBooks', to: '/audiobooks/homeview', icon: 'mdi-headphones' },
      { title: 'Wish list', to: '/audiobooks/wishlist', icon: 'mdi-bookmark-plus' },
      { title: 'Add audiobook', to: '/audiobooks/add-post', icon: 'mdi-plus' },
      { title: 'Search', to: '/audiobooks/search', icon: 'mdi-magnify' },
    ],
  },
  comics: {
    key: 'comics',
    title: 'Comics',
    icon: 'mdi-draw',
    color: '#f59e0b',
    gradient: 'linear-gradient(135deg, #f59e0b, #fbbf24)',
    items: [
      { title: 'Comics', to: '/comics/homeview', icon: 'mdi-draw' },
      { title: 'Wish list', to: '/comics/wishlist', icon: 'mdi-bookmark-plus' },
      { title: 'Add comic', to: '/comics/add-post', icon: 'mdi-plus' },
      { title: 'Search', to: '/comics/search', icon: 'mdi-magnify' },
    ],
  },
}

const SECTION_PREFIXES = [
  { key: 'movies', prefix: '/movies' },
  { key: 'books', prefix: '/books' },
  { key: 'audiobooks', prefix: '/audiobooks' },
  { key: 'comics', prefix: '/comics' },
]

export function getActiveSection(path) {
  const match = SECTION_PREFIXES.find(({ prefix }) => path.startsWith(prefix))
  return match?.key ?? null
}

export function getSectionNav(section) {
  return section ? NAV_SECTIONS[section] : null
}
